import { render, staticRenderFns } from "./StandardWorkingPeriod.vue?vue&type=template&id=2fcdd5e8"
import script from "./StandardWorkingPeriod.vue?vue&type=script&lang=js"
export * from "./StandardWorkingPeriod.vue?vue&type=script&lang=js"
import style0 from "./StandardWorkingPeriod.vue?vue&type=style&index=0&id=2fcdd5e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports